import React from 'react';

class Seperator extends React.Component {
    render() {
        return (<div className="seprator-container">

        </div>)
    }
}

export default Seperator;